import { Component, HostBinding, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../../core/services/logger.service';
import { TagManagerService } from '../../../core/services/tag-manager.service';
import { CareersService } from '../../../services/careers.service';
import { IWidgetComponent } from '../../../shared/widget/i-widget-component';
import { Widget } from '../../../shared/widget/widget';


@Component({
    selector: 'app-job-postings',
    templateUrl: './job-postings.component.html',
    styleUrls: ['./job-postings.component.scss'],
    standalone: false
})
export class JobPostingsComponent implements OnInit, OnDestroy, IWidgetComponent
{
    public data: Widget;   
   
    public jobs: any[];
    public events: any[];
    public modalTitle: string;
    public dateType: string;
  
    public careerData$: Observable<any>;

    @HostBinding('class')
    get size(): string {
        var widgetSize = 'col-md-' + this.data.Size.toString();

        switch (this.data.Size) {
            case 4: {
                widgetSize += ' widget-small';
                break;
            }
            case 6: {
                widgetSize += ' widget-medium';
                break;
            }
            case 12: {
                widgetSize += ' widget-large';
                break;
            }
        }

        return widgetSize;
    }

    constructor(
        private logger: LoggerService,
        public careers: CareersService,        
        private gtm: TagManagerService,
        private modalService: NgbModal
    ) {
        this.log("constructor", null, LogCategory.Constructor);
                
        this.careerData$ = this.careers.jobpostings$.pipe(          
            map((content => {
                let jobs = content.postings;
                let data = {                           
                    baseUrl: content.baseUrl,
                    allCount: jobs.length,
                    firstRow :[],
                    secondRow : []
                };
                data.firstRow.push({
                    title: 'Due Soon',
                    data: jobs.filter(job => job.IsDueSoon),
                    dateType: 'Created'
                });
                data.firstRow.push({
                    title: 'Recently Added',
                    data: jobs.filter(job => job.IsNewPosting).sort(function (a, b) {
                        if (a.CreatedDate > b.CreatedDate) { return -1; } if (a.CreatedDate < b.CreatedDate) { return 1; } return 0
                    }),
                    dateType: 'Created'
                });
                data.firstRow.push({
                    title: 'Recently Updated',
                    data: jobs.filter(job => job.IsUpdated).sort(function (a, b) {
                        if (a.ModifiedDate > b.ModifiedDate) { return -1; } if (a.ModifiedDate < b.ModifiedDate) { return 1; } return 0
                    }),
                    dateType: 'Updated'
                });

                data.secondRow.push({
                    title: 'Full-Time Jobs',
                    data: jobs.filter(job => job.IsFullTime),
                    dateType: 'Created'
                });
                data.secondRow.push({
                    title: 'Internships',
                    data: jobs.filter(job => job.IsInternship),
                    dateType: 'Created'
                });
                data.secondRow.push({
                    title: 'Other Jobs',
                    data: jobs.filter(job => job.IsOtherJobPhase),
                    dateType: 'Created'
                });

                return data;
            })
         ));

    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.JobPostings, category);
    }

    ngOnInit(): void {
        this.log("ngOnInit", null, LogCategory.Init);
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", "", LogCategory.Destroy);       
    }

    public openModal(jobs, content) {
        this.gtm.gaLinkClicked('Job Postings', jobs.title);       
        this.jobs = jobs.data;
        this.modalTitle = jobs.title;
        this.dateType = jobs.dateType;
        this.modalService.open(content, { size: 'lg', scrollable: true });
    }    
}

